<template>
  <div class="sn-page sn-assembly sn-f-c-c sn-popup" @click="cancel ? sendBack(false) : null;">
    <div class="popup" @click.stop="">
      <div class="sn-f-b-c title">
        <div>{{ title }}</div>
        <div class="iconfont icon-guanbi" @click="sendBack(false);"></div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'sn-popup',
  props: {
    title: {
      type: String,
      default: ''
    },
    cancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    sendBack(type) {
      this.$emit('sendBack', type);
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else if (url.substring(0, 4) === 'http' || url.substring(0, 7) === '/static' || url.substring(0, 2) === '//') {
        window.location.href = url;
      }
      else {
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.sn-popup {
  background-color: $mask;
  z-index: 10000;

  .popup {
    overflow: hidden;
    width: 500px;
    background-color: $white;
    border: 1px solid $main;
    border-radius: 5px;

    .title {
      @include fs(16);

      width: 100%;
      height: 40px;
      background-color: $main;
      color: $white;
      padding: 0 10px;

      .iconfont {
        font-size: 12px;
        color: $white;
      }
    }
  }
}
</style>
